import React from 'react';
import { Modal, Image } from '@mantine/core';
import { Annotation } from '@/types/Annotation.model';
import { isSafeAnnotationImageSrc } from '@/utils/annotationUtils';

interface AnnotationImageModalProps {
  opened: boolean;
  onClose: () => void;
  annotation: Annotation | null;
  ImageComponent?: typeof Image; // Allow custom Image component (e.g., MantineImage)
  /** Portal into this node when browser fullscreen so the modal stays above the fullscreen layer. */
  portalTarget?: HTMLElement | string;
  /** Raise above theater backdrop (2000) / in-stage overlays when immersive. */
  modalZIndex?: number;
}

/**
 * Modal component for displaying annotation images
 * Shows the annotation image in a centered modal
 */
export function AnnotationImageModal({
  opened,
  onClose,
  annotation,
  ImageComponent = Image,
  portalTarget,
  modalZIndex,
}: AnnotationImageModalProps) {
  if (!opened || !annotation?.image || !isSafeAnnotationImageSrc(annotation.image)) {
    return null;
  }

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={annotation.title}
      centered
      size="lg"
      closeOnClickOutside
      closeOnEscape
      withCloseButton
      keepMounted={false}
      zIndex={modalZIndex}
      portalProps={portalTarget ? { target: portalTarget } : undefined}
    >
      <ImageComponent
        src={annotation.image}
        alt={annotation.title}
        style={{ width: '100%', height: 'auto' }}
      />
    </Modal>
  );
}

